import { render } from "./SolucaoView.vue?vue&type=template&id=2215b548&scoped=true"
import script from "./SolucaoView.vue?vue&type=script&lang=js"
export * from "./SolucaoView.vue?vue&type=script&lang=js"

import "./SolucaoView.vue?vue&type=style&index=0&id=2215b548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2215b548"]])

export default __exports__